import { ArrowDown } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen pt-28 sm:pt-32 pb-16 sm:pb-24 overflow-hidden"
    >
      {/* Layered background — subtle Transform Your Life texture */}
      <div className="absolute inset-0 -z-20 bg-cm-cream" />
      <div
        aria-hidden
        className="absolute inset-0 -z-10 bg-cover bg-center opacity-75"
        style={{
          backgroundImage: "url('/brand/cm-transform.jpg')",
          filter: "saturate(1.1)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 -z-10"
        style={{
          background:
            "linear-gradient(180deg, rgba(249,246,240,0.35) 0%, rgba(249,246,240,0.6) 55%, rgba(249,246,240,0.92) 100%)",
        }}
      />
      <div
        aria-hidden
        className="absolute -z-10 right-[-220px] top-[-220px] w-[640px] h-[640px] rounded-full blur-3xl opacity-30"
        style={{ background: "radial-gradient(circle, #E8C7C0 0%, transparent 60%)" }}
      />
      <div className="grain absolute inset-0 -z-10" />

      <div className="max-w-[1280px] mx-auto px-5 sm:px-10 lg:px-16 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 reveal">
          <span className="ornament" data-testid="hero-eyebrow">
            <em>Velkommen</em>
          </span>

          <h1
            data-testid="hero-headline"
            className="font-serif text-cm-ink mt-8 text-[1.85rem] sm:text-5xl lg:text-[4rem] leading-[1.12] sm:leading-[1.08] tracking-[-0.01em]"
          >
            Lever du for at undgå{" "}
            <span className="marker">det, du ikke vil have</span>
            <br className="hidden sm:block" />
            {" "}— eller for at skabe{" "}
            <span className="marker">det, du længes efter?</span>
          </h1>

          <p
            data-testid="hero-subtext"
            className="mt-8 sm:mt-10 text-base sm:text-lg text-cm-ink-soft leading-relaxed max-w-xl"
          >
            Som coach møder jeg dig dér, hvor du er. Jeg hjælper dig med at finde
            roen i overgangen og styrken til at skabe din fremtid.
            <span className="block mt-3 font-serif italic text-cm-ink">
              Dit næste skridt starter her.
            </span>
          </p>

          <div className="mt-10 sm:mt-12 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-6">
            <button
              data-testid="hero-cta-book"
              onClick={() => scrollTo("kontakt")}
              className="cm-btn"
            >
              Book en introsamtale
              <span aria-hidden>→</span>
            </button>
            <button
              data-testid="hero-cta-learn"
              onClick={() => scrollTo("narrativ")}
              className="cm-btn cm-btn-ghost"
            >
              Læs min tilgang
            </button>
          </div>

          <div className="mt-14 sm:mt-20 flex flex-wrap items-center gap-x-4 sm:gap-x-6 gap-y-2 sm:gap-y-3 text-cm-ink-soft text-[0.65rem] sm:text-xs tracking-[0.22em] sm:tracking-[0.24em] uppercase">
            <span>Lifecoach</span>
            <span className="w-1 h-1 rounded-full bg-cm-rose" />
            <span>Mastercoach</span>
            <span className="w-1 h-1 rounded-full bg-cm-rose" />
            <span>Stresscoach</span>
            <span className="w-1 h-1 rounded-full bg-cm-rose" />
            <span>Relationshipcoach</span>
            <span className="w-1 h-1 rounded-full bg-cm-rose" />
            <span>NADA-udøver</span>
            <span className="w-1 h-1 rounded-full bg-cm-rose" />
            <span>Socialrådgiver</span>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="reveal relative max-w-[320px] sm:max-w-[420px] lg:max-w-[480px] mx-auto">
            <div className="relative rounded-sm overflow-hidden border border-cm-line bg-cm-surface shadow-[0_30px_60px_-30px_rgba(196,139,139,0.45)]">
              <img
                src="/brand/cristina-portrait.jpg"
                alt="Cristina Mona — Mastercoach"
                loading="eager"
                data-testid="hero-image-main"
                className="w-full h-auto block transition-transform duration-[1600ms] hover:scale-[1.03]"
              />
            </div>
            <div
              aria-hidden
              className="absolute -top-4 -right-4 hidden sm:block w-24 h-24 rounded-full border border-cm-rose/30 pointer-events-none"
            />
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollTo("narrativ")}
        data-testid="hero-scroll-indicator"
        className="hidden md:flex absolute bottom-10 left-1/2 -translate-x-1/2 items-center gap-3 text-cm-ink-soft text-[0.7rem] tracking-[0.3em] uppercase hover:text-cm-rose transition-colors"
      >
        Scroll
        <ArrowDown size={14} className="animate-bounce" />
      </button>
    </section>
  );
}
